import { render, staticRenderFns } from "./FacilityEditTabLocation.vue?vue&type=template&id=6a1e58a2&"
import script from "./FacilityEditTabLocation.vue?vue&type=script&lang=js&"
export * from "./FacilityEditTabLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports